// 聚合h5KNB和Native提供的KNB
// https://km.sankuai.com/collabpage/407809279
import webKNB from './webKNB';

// 因CDN的knb是在加载完自执行挂在到window.KNB
// 故其不可async加载，否则时序不好保证，影响此处的纯H5覆盖。
const globalKNB = { ...window.KNB || {} };
const isInApp = () => globalKNB.env?.isTitans;

const KNB = {
  ...globalKNB,
  ...Object.entries(webKNB).reduce((p, [knbName, webKNBFunc]) => ({
    ...p,
    [knbName]: (() => {
      const func = (...args) => {
        try {
          if (isInApp()) {
            globalKNB[knbName](...args);
          } else {
            globalKNB[knbName] = webKNBFunc;
            // @ts-ignore
            webKNBFunc(...args);
          }
        } catch (e) {
          console.log(`webknb-${knbName}-error`, e);
          // @ts-ignore
          args?.[0]?.fail(e);
        }
      };

      if (knbName === 'setResult') {
        // @ts-ignore
        func.RESULT_OK = webKNBFunc.RESULT_OK;
      }
      return func;
    })(),
  }), {}),
};

export default KNB;
